import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Box, ClickAwayListener, SxProps, Theme, Typography } from '@mui/material';

type ProfileSelectXClearProps = Readonly<{
  label: string;
  isHovering: boolean;
  setIsHovering: (isHovering: boolean) => void;
  onDelete: () => void;
  disabled?: boolean;
}>;

export const ProfileSelectXClear = ({
  isHovering,
  setIsHovering,
  label,
  onDelete,
  disabled,
}: ProfileSelectXClearProps) => {
  return (
    <ClickAwayListener onClickAway={() => setIsHovering(false)}>
      <Box sx={profileSelectXClearSx}>
        <Typography sx={labelSx}>{label}</Typography>
        <Box
          sx={{
            ...xContainerSx,
            opacity: isHovering && !disabled ? 1 : 0,
            pointerEvents: disabled ? 'none' : 'auto',
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();

            if (disabled) return;

            onDelete();
          }}
          onMouseDown={(e) => {
            if (disabled) return;

            e.stopPropagation();
          }}
        >
          <AppIcon iconName="XClose" diameter="12px" color="Gray/500" />
        </Box>
      </Box>
    </ClickAwayListener>
  );
};

const profileSelectXClearSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  overflow: 'hidden',
  pr: backrs.spacing['spacing-4xl'],
});

const xContainerSx: SxProps<Theme> = ({ backrs }) => ({
  cursor: 'pointer',
  transition: 'opacity 0.3s ease-in-out',
  backgroundColor: backrs.colors['Colors/Base/White'],
  zIndex: 1000,
});

const labelSx: SxProps<Theme> = () => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flex: 1,
});
